<template>
  <div class="mian_view">
    <!-- 搜索 -->
    <div class="waitingcom_title">
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="练习名称：">
          <el-input
            v-model.trim="formLabelAlign.practiceName"
            placeholder="请输入练习名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="组卷模式：">
          <el-select v-model="formLabelAlign.examModel" @change="queryChange">
            <el-option
              v-for="item in examModelArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="练习状态：">
          <el-select
            v-model="formLabelAlign.practiceStatus"
            @change="handleQuery"
          >
            <el-option
              v-for="item in examStatusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="formLabelAlign.examTime"
            @change="handleQuery"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetForm('formLabelAlign')"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div class="mian_table" v-loading="loading">
      <el-table
        :data="getData"
        style="width: 100%"
        :cell-class-name="stateColor"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (pageIndex - 1) * eachPageNum + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="练习名称" align="center" width="150"
          ><template slot-scope="scope">
            <span>{{ scope.row.ExamName }}</span>
            <el-tooltip placement="right-start" effect="darkts">
              <div slot="content" class="bubbles_box">
                <div
                  class="bubbles_son"
                  style="color: #ffffff; background-color: #00d254"
                >
                  <p>总分:{{ scope.row.TotalScore }}分</p>
                  <p>时间:{{ scope.row.SpendTime }}分钟</p>
                </div>

                <br />
                <div
                  class="bubbles_son"
                  style="color: #ffffff; background-color: #00d254"
                >
                  <p>参考人员:{{ scope.row.StudentCount }}人</p>
                  <p>及格线:{{ scope.row.PassScore }}分</p>
                </div>
              </div>
              <i class="iconfont icon-tishi"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="170">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                verification="xxy:shuffling:goAbroad:detail"
                type="text"
                size="small"
                @click="setClick(scope.row)"
                >练习设置</el-button
              >
              <el-button
                verification="xxy:shuffling:goAbroad:delete"
                type="text"
                size="small"
                @click="queryClick(scope.row)"
                >练习查询</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗 -->
    <sys-dialog
      :title="editTimeDialog.title"
      :width="editTimeDialog.width"
      :height="editTimeDialog.height"
      :visible="editTimeDialog.visible"
      @onConfirm="editConfirm"
      @onClose="editClose"
    >
      <div slot="content" class="message-text">
        <div class="bacle_input">
          <h5>考试时间：</h5>
          <div class="examTimeSelect">
            <el-date-picker
              v-model="timeSelect"
              @change="timechange"
              value-format="yyyy-MM-dd HH:mm"
              class="standard_input"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="bacle_input">
          <h5>答题时长：</h5>
          <el-input
            v-model="timeValue"
            maxlength="3"
            placeholder="不应低于10分钟"
            class="standard_input"
          ></el-input>
          <p>分钟</p>
        </div>
      </div>
    </sys-dialog>
  </div>
</template>

<script>
import {
  practiceArr,
  examModelArr,
  examStatusArr,
  ChannelMerger,
} from "@/state/practiceModel";
import loginvuex from "@/store/index";
import $examApi from "@/api/examApi.js";
import SysDialog from "@/components/system/SysDialog";
import { hybrid } from "@/mixin/mixin";
import training from "@/api/trainingApi";
import { typeTestPaper } from "@/utils/topicImg"; // 题型图片处理
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        practiceName: "", // 练习名称
        examModel: "", // 组卷模式
        practiceStatus: "", // 练习状态
        examTime: "", // 创建时间
        createBeginTime: "",
        createEndTime: "",
      },
      timeValue: "",
      getDataCondition: {
        practiceName: "", // 练习名称
      },
      editTimeDialog: {
        title: "考试时间设置",
        width: 800,
        height: 150,
        visible: false,
      },
      timeSelect: [],
      examModelArr: [],
      examStatusArr: [],
      formColumns: [],
      getData: [{ channel: "测试数据", ExamName: "测试名称" }], // 表格数据
      pageIndex: 1, // 起始页
      eachPageNum: 10, // 一页多少条数据
      total: 100,
      loading: false,
      pagesun: "", // 一共多少页
      pagesizesarr: [5, 10, 20, 50, 100],
      examId: "",
      lastBeginTime: "",
      pickerOptions: {
        disabledDate(date) {
          // 2022-06-25之前时间全部禁用
          if (date.getTime() < new Date("2022-06-24")) {
            return true; // true代表禁用
          }
          return false;
        },
      },
    };
  },
  props: ["cutcoms"],
  mixins: [hybrid],
  methods: {
    // 搜索
    handleQuery() {
      this.pageIndex = 1;
      if (this.formLabelAlign.practiceName) {
        this.getDataCondition.practiceName = this.formLabelAlign.practiceName;
      } else {
        this.getDataCondition.practiceName = "";
      }
      this.loading = true;
      this.getDatalist();
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      //   console.log('object', row, column, rowIndex, columnIndex)
      if (row.IsPublish === "练习中" && columnIndex === 5) {
        return "yellow";
      } else if (row.IsPublish === "练习结束" && columnIndex === 5) {
        return "red";
      } else if (row.IsPublish === "待练习" && columnIndex === 5) {
        return "green";
      }
    },
    // chang查询
    queryChange() {
      this.loading = true;
      if (this.formLabelAlign.examTime == null) {
        this.formLabelAlign.createBeginTime = "";
        this.formLabelAlign.createEndTime = "";
      }
      this.getDatalist();
    },
    // 考试状态
    ChannelMerger() {
      // 组卷模式
      this.getData = this.getData.map((item) => {
        if (item.PaperMode === "unified_db") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "智能组卷";
        } else if (item.PaperMode === "random_db") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "智能组卷";
        } else if (item.PaperMode === "unified_exam") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "试卷组卷";
        } else if (item.PaperMode === "random_exam") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "试卷组卷";
        } else if (item.PaperMode === "unified_Proportion") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "权重组卷";
        } else if (item.PaperMode === "random_Proportion") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "权重组卷";
        } else if (item.PaperMode === "sg_db") {
          item.PaperModeName = "手动命题";
          item.PaperModeExam = "精准组卷";
        } else if (item.PaperMode === "paper") {
          item.PaperModeExam = "纸质试卷";
        } else if (item.PaperMode === "unified_difflever") {
          item.PaperModeExam = "难易度组卷";
          item.PaperModeName = "统一命题";
        } else if (item.PaperMode === "random_difflever") {
          item.PaperModeExam = "难易度组卷";
          item.PaperModeName = "随机命题";
        }
        item.CreateTime1 = this.$moment(item.CreateTime).format(
          "YYYY/MM/DD HH:mm"
        );
        // 时间拼接
        item.BeginTime1 =
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
          "-" +
          this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
        // 时间处理
        if (item.BeginTime1 == "Invalid date-Invalid date") {
          item.BeginTime1 = "暂无";
        }
        // 代考人数的计算
        item.StudentCount1 = item.StudentCount - item.AlreadyStuCount;
        if (item.StudentCount1 < 0) {
          item.StudentCount1 = 0;
        }
        // 练习状态
        if (item.BeginTime > item.ServerTime && item.IsPublish === 1) {
          this.$set(item, "IsPublish", "待练习");
        }
        if (
          item.ServerTime >= item.BeginTime &&
          item.IsPublish === 1 &&
          item.ServerTime < item.EndTime
        ) {
          this.$set(item, "IsPublish", "练习中");
        }
        if (item.ServerTime > item.EndTime && item.IsPublish === 1) {
          this.$set(item, "IsPublish", "练习结束");
        }
        return item;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formLabelAlign = {
        practiceName: "", // 练习名称
        examModel: "", // 组卷模式
        practiceStatus: "", // 练习状态
        examTime: "", // 创建时间
        createBeginTime: "",
        createEndTime: "",
      };
      this.getDataCondition.practiceName = "";
      this.loading = true;
      this.getDatalist();
    },
    // 表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.loading = true;
      this.getDatalist();
    },
    // 初始
    theInitial() {
      this.formColumns = practiceArr;
      this.examModelArr = examModelArr;
      this.examStatusArr = examStatusArr;
    },
    // 获取表格数据
    async getDatalist() {
      if (this.formLabelAlign.examTime) {
        const time = JSON.parse(JSON.stringify(this.formLabelAlign.examTime));
        this.formLabelAlign.createBeginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.createEndTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let parameter = {
        pageIndex: this.pageIndex - 1, // 页数
        eachPageNum: this.eachPageNum, // 条数
        userID: JSON.parse(loginvuex.state.userlist).userID, // 用户ID
        guid: JSON.parse(loginvuex.state.userlist).guid, // token
        type: 1, // 试卷类型,0考试,1练习,2纸质,3视频试卷
        examName: this.getDataCondition.practiceName, // 考试名称
        examModel: this.formLabelAlign.examModel, // 组卷模式
        examStatus: this.formLabelAlign.practiceStatus, // 0 待考试 1考试中 2考试结束
        createBeginTime: this.formLabelAlign.createBeginTime, // 开始时间
        createEndTime: this.formLabelAlign.createEndTime, // 结束时间
        operatUserID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const { data } = await $examApi.getList(parameter);
      if (data.Status == 200) {
        this.total = data.Data.count;
        this.getData = data.Data.data;
        this.pagesun = data.Data.pageCount;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.ChannelMerger();
        console.log(data, "拿到数据了");
      } else {
        this.$message.error(data.message);
      }
    },
    // 设置
    setClick(row) {
      console.log(row, "999");
      if (row.IsPublish == "练习中") {
        // 练习中唤起弹窗只能修改时间
        this.examId = row.ExamID;
        this.lastBeginTime = row.BeginTime;
        this.timeSelect = [];
        this.timeSelect[0] = this.$moment(row.BeginTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.timeSelect[1] = this.$moment(row.EndTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.timeValue = row.SpendTime;
        this.editTimeDialog.visible = true;
      } else {
        // 跳转去执行编辑
        sessionStorage.setItem("lxszRow", JSON.stringify(row));
        this.$router.push({
          path: "/testpapers",
          query: {
            type: "editor",
          },
        });
        // 跳到在线练习的编辑页
      }
    },
    // 查询
    queryClick(row) {
      this.$parent.currentLine = row;
      this.cutcoms(1);
    },
    async init() {
      if (this.$route.query.trainId) {
        const obj = {
          scoreId: this.$route.query.scoreId,
          type: this.$route.query.examType,
          typeId: this.$route.query.typeId,
        };
        const { data } = await training.getTypeDetail(obj);
        if (data.Status == 200) {
          const typeTest = typeTestPaper(data.Data.PaperMode);
          data.Data.PaperModeName = typeTest.PaperModeName;
          data.Data.PaperModeExam = typeTest.PaperModeExam;
          this.$parent.currentLine = data.Data;
          this.cutcoms(1);
        } else {
          this.$message.error(data.Data);
        }
      }
    },
  },
  components: {
    SysDialog,
  },
  created() {
    this.theInitial();
    this.getDatalist();
    this.init()
  },
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.mian_view {
  // height: 100%;
  width: 100%;
  min-height: 780px;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  display: flex;
  justify-content: center;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  display: flex;
  justify-content: center;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  display: flex;
  justify-content: center;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.icon-tishi {
  display: inline-block;
  // transform: translate(-6px, -5px) scale(0.6);
  &::before {
    color: #cad8d0;
    display: inline-block;
  }
}

// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 115px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}
.mian_table {
  background: #ffffffff;
  // height: 700px;
  padding: 24px;
  .add_btn {
    width: 96px;
    height: 40px;
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
    color: #ffffff;
    margin-bottom: 14px;
  }

  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(13) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  ::v-deep .el-table td > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      color: #1890ff;
      font-weight: 400;
      &:nth-child(3) {
        color: #ff4747;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
.bacle_input {
  display: flex;
  padding-right: 40px;
  .examTimeSelect {
    ::v-deep .el-date-editor {
      width: 550px;
    }
    margin-bottom: 30px;
  }
  ::v-deep .el-input {
    width: 550px;
  }
  h5 {
    display: inline-block;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
  p {
    margin-left: 10px;
    line-height: 40px;
    text-align: center;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #1890ff;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #1890ff;
        border: none;
      }
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.is-darkts {
  background: #00d254;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
</style>
